// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import CityTable from "../../DataTables/MasterData/City/CityTable";

// Modals
import CreateCityModal from "../../UiKits/Modal/MasterData/City/CreateCity";

const CityContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="City/Municipality"
        parent="Master Data / Address & Location"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">City / Municipality Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage city / municipality options used throughout the HRIS
                  for employee and applicant personal information.
                </P>
                <CreateCityModal />
                <CityTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CityContainer;
